import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogEmailComponent } from './dialog-email/dialog-email.component';
import { speedDialFabAnimations } from './speed-dial.animations';
import { FvrZeropaySupportPopupService } from './fvr-zeropay-support-popup.service';

@Component({
  selector: 'fevertree-support',
  templateUrl: 'fvr-zeropay-support-popup.component.html',
  styleUrls: ['fvr-zeropay-support-popup.component.css'],
  animations: [speedDialFabAnimations],
})
export class FvrZeropaySupportPopupComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private eRef: ElementRef,
    private support: FvrZeropaySupportPopupService
  ) {}

  @Input() enableEmail: boolean = true;
  @Input() enablePhone: boolean = true;
  @Input() enableLiveChat: boolean = false;
  @Input() email!: string;
  @Input() cc: string = '';
  @Input() bcc: string = '';
  @Input() cellNumber!: string;
  @Input() sourceImage!: string;
  @Input() sourceName!: string;
  @Input() topicOptions!: string[];
  @Input() selectedOption!: number;
  @Input() prefilledMessage!: string;
  @Input() prefilledName!: string;
  @Input() prefilledEmail!: string;
  @Input() allowFileUploads: boolean = false;
  @Input() icon: string = 'support';
  @Input() tooltip: string = 'Support';
  @Input() emailTooltip: string = 'Email us';
  @Input() phoneTooltip: string = 'Call us';
  @Input() backgroundColor: string = '#ff5722';
  @Input() foregroundColor: string = '#f2f2f2';
  @Input() speedDialBackgroundColor: string = '#bf360c';
  @Input() speedDialForegroundColor: string = '#f2f2f2';
  @Input() formFieldAppearance: 'fill' | 'outline' | 'standard' | 'legacy' =
    'fill';
  @Input() dialogTitleText: string = 'How can we help you?';
  @Input() dialogInfoText: string =
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facilis repellat accusamus atque blanditiis placeat minima maiores sit hic aut voluptas, eligendi consectetur quo autem id dignissimos soluta quos dolor est.';
  @Output() emailSubmissionEvent = new EventEmitter<void>();

  public active = false;
  public fabButtons: any[] = [];
  public buttons: any[] = [];
  public fabTogglerState = 'inactive';
  public isMobile = false;
  public subscription!: Subscription;

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 720;

    this.subscription = this.support.contactDialogEvent.subscribe(() => {
      this.dialog.open(DialogEmailComponent, {
        panelClass: 'custom-dialog-container',
        data: {
          formFieldAppearance: this.formFieldAppearance,
          btnBackground: this.backgroundColor,
          btnForeground: this.foregroundColor,
          submit: (form: any) => {
            this.emailSubmissionEvent.emit(form);
          },
          emailTo: this.email,
          cc: this.cc,
          bcc: this.bcc,
          sourceImage: this.sourceImage,
          sourceName: this.sourceName,
          titleText: this.dialogTitleText,
          infoText: this.dialogInfoText,
          panelBackground: this.speedDialBackgroundColor,
          panelForeground: this.speedDialForegroundColor,
          topicOptions: this.topicOptions,
          selectedOption: this.selectedOption,
          prefilledMessage: this.prefilledMessage,
          prefilledName: this.prefilledName,
          prefilledEmail: this.prefilledEmail,
          allowFileUploads: this.allowFileUploads,
        },
        width: this.isMobile ? '100%' : '50%',
      });

      this.hideItems();
    });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.hideItems();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth <= 720;
  }

  ngAfterViewInit(): void {
    this.fabButtons = [];

    if (this.enableLiveChat)
      this.fabButtons.push({
        icon: 'support_agent',
        tooltip: 'Live Chat',
        action: () => {
          this.hideItems();
        },
      });

    if (this.enablePhone)
      this.fabButtons.push({
        icon: 'phone',
        tooltip: this.phoneTooltip,
        action: () => {
          window.location.href = `tel:${this.cellNumber}`;
          this.hideItems();
        },
      });

    if (this.enableEmail)
      this.fabButtons.push({
        icon: 'mail',
        tooltip: this.emailTooltip,
        action: () => {
          this.dialog.open(DialogEmailComponent, {
            panelClass: 'custom-dialog-container',
            data: {
              formFieldAppearance: this.formFieldAppearance,
              btnBackground: this.backgroundColor,
              btnForeground: this.foregroundColor,
              submit: (form: any) => {
                this.emailSubmissionEvent.emit(form);
              },
              emailTo: this.email,
              cc: this.cc,
              bcc: this.bcc,
              sourceImage: this.sourceImage,
              sourceName: this.sourceName,
              titleText: this.dialogTitleText,
              infoText: this.dialogInfoText,
              panelBackground: this.speedDialBackgroundColor,
              panelForeground: this.speedDialForegroundColor,
              topicOptions: this.topicOptions,
              selectedOption: this.selectedOption,
              prefilledMessage: this.prefilledMessage,
              prefilledName: this.prefilledName,
              prefilledEmail: this.prefilledEmail,
              allowFileUploads: this.allowFileUploads,
            },
            width: this.isMobile ? '100%' : '50%',
          });

          this.hideItems();
        },
      });
  }

  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
